import React from "react";
const AuditoriumOptions = React.memo(props => {
    var auditoriumOptionsArray = ["","","","","",""];
    var myOptions = props.items;
    myOptions = myOptions.substring(1); // cut the first char from the string- the char is ';'
    var index = 0;
    var moreOptions = true;
    var optionKeyIindex = 0;
    var emptyCells=false;

    while (moreOptions)
    {
        auditoriumOptionsArray[index] = myOptions.substring(
            myOptions.indexOf("#") +1, 
            myOptions.indexOf(";")
        );
    
        index++;
        myOptions = myOptions.substring(
            myOptions.indexOf(";") +1
        );
        if (myOptions.length <2){
            moreOptions=false;
        }    
    }
    return (    
        <React.Fragment>
            <ul className="optionData">{auditoriumOptionsArray.map((dat1) => {
                optionKeyIindex++;
                if ((!emptyCells)&&(dat1 ==="")&&(optionKeyIindex%2==1)){
                    emptyCells=true;
                }
                return(
                    <li className= "optionTableCell" key={dat1 + optionKeyIindex}>
                        {dat1 ==="" ? (emptyCells?<span className="emptyAuditoriomOpton"></span>:<span>&nbsp;</span>) : <span>{dat1}</span>}
                    </li>
                )})}</ul>
        </React.Fragment>
    );
});

export default AuditoriumOptions;


